module.exports = __webpack_public_path__ + "img/joaquin-urien.389004f6.jpg";